import { parseApiDate } from './format';

const EMPTY_HISTORY_VALUE = '—';
const DISPLAY_TZ = 'Asia/Tokyo';

/** Format a history timestamp using the locale supported by the current UI. */
export function formatHistoryDateTime(value, language = 'en') {
  if (!value) return EMPTY_HISTORY_VALUE;
  const date = parseApiDate(value);
  if (Number.isNaN(date.getTime())) return EMPTY_HISTORY_VALUE;
  return new Intl.DateTimeFormat(
    String(language).startsWith('ja') ? 'ja-JP' : 'en-GB',
    {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      timeZone: DISPLAY_TZ,
    },
  ).format(date).replace(', ', ' ');
}
